import React from 'react'
function BannerInfoGd() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      <h2 className="card-title">GOBERNANZA DE DATOS</h2>
      <p className="card-text">
      Para la conformación de una IDE se requiere de la colaboración de las áreas que proveen
datos geoespaciales. Para esto se establecen acuerdos de cooperación entre las mismas
que ordenan y regulan la publicación de los datos que cada una de ellas producen.
      </p>
      <div className="panel-footer">
        <p>
        Existen diferentes tipos de actores dentro del Gobierno de la Ciudad que, según la
información que generan, aportan:<br/><br/>
- datos básicos y fundamentales (DByF),<br/>
- datos que por Ley deben ser publicados al ciudadano al ser de interés general (Ley 2525)<br/>
- datos que son de uso interno del GCABA pero que podrían ser de utilidad y transversales
a otras áreas
        </p>
      </div>
    </div>
  </div>
</div>

  )
}

export default BannerInfoGd